import _ from 'lodash'

export default ({ values }, key) => _.filter(_.get(values, key), 'enabled')
